import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import SiteVisitDetails from "./SiteVisitDetails";
import SiteVisitHeader from "./SiteVisitHeader";
import { useParams } from "react-router-dom";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import {
  loadSiteVisitAsync,
  selectSiteVisit,
} from "../../../redux/slices/siteVisit";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import Page500 from "../../../pages/auth/Page500";

const SiteVisit = () => {
  const [loading, setLoading] = useState(false);
  const [loadingSiteVisitId, setLoadingSiteVisitId] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const siteVisitSelector = useAppSelector(selectSiteVisit);

  const dispatch = useAppDispatch();

  let { profileNo, siteVisitId } = useParams();
  if (!profileNo || !siteVisitId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
    return <Loading />;
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingSiteVisitId !== siteVisitId) {
    setLoadingSiteVisitId(siteVisitId);
    dispatch(loadSiteVisitAsync(siteVisitId));
    return <Loading />;
  }

  const siteVisit = siteVisitSelector.siteVisit;

  if (!siteVisit) {
    return <Loading />;
  }

  if (!siteVisit.response.ok) {
    if (siteVisit.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <SiteVisitHeader siteVisit={siteVisit} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <SiteVisitDetails siteVisit={siteVisit} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords
            siteVisit={siteVisit}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs licenceProfile={licenceProfile} siteVisit={siteVisit} />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default SiteVisit;
